const MEETS_REQUIREMENTS_TYPES = {
  YES: {
    value: "yes",
    readableName: "Yes",
  },
  NO: {
    value: "no",
    readableName: "No",
  },
  UNDER_REVIEW: {
    value: "under_review",
    readableName: "Under review",
  },
};

// Convert the object to an array of entries
export const amlRelianceLetterMeetsRequirementsTypesArray =
  Object.values(MEETS_REQUIREMENTS_TYPES);

const AML_DOCUMENT_TYPES = {
  AML_RELIANCE_COMFORT_LETTER: {
    value: "aml_reliance_comfort_letter",
    readableName: "AML Reliance Comfort Letter",
  },
};

export const amlRelianceLetterDocumentTypesArray = Object.values(AML_DOCUMENT_TYPES);
